
export const createVenueData = ({
  related_files = [],
  fields = [],
  external_table = '',
  locations = [createLocations({})],
  section = '',
  related_genres = [createRelatedGenre({})],
  template_location_bookings = '',
  private_comments = [createComment()],
  template_related_files = '',
  user = createUser({}),
  contact_relations_template_type = '',
  location = createLocation({}),
  status = [createStatus({})],
  files = [],
  template_location_airports = '',
  action = undefined,
  external_id = 0,
  contact_search_type = '',
  file_relation_external_table = '',
  artists = [createArtists({})],
  client = createClient({}),
  public_comments = [createComment()],
  clientID = '',
  contact_relations = [createContact_relation()],
  contact_id = 0,
  template_widgets_contact_relations_standard = '',
  countries = [''],
  promoters = [createPromoters({})],
  file_relation_external_id = 0
}) => {
  return {
    related_files,
    fields,
    external_table,
    locations,
    section,
    related_genres,
    template_location_bookings,
    private_comments,
    template_related_files,
    user,
    contact_relations_template_type,
    location,
    status,
    files,
    template_location_airports,
    action,
    external_id,
    contact_search_type,
    file_relation_external_table,
    artists,
    client,
    public_comments,
    clientID,
    contact_relations,
    contact_id,
    template_widgets_contact_relations_standard,
    countries,
    promoters,
    file_relation_external_id
  }
};

const createContact_relation = ({
  contact_name = '',
  last_modified = '',
  travel_flag = undefined,
  request_flag = undefined,
  phone2 = undefined,
  main_company_flag = undefined,
  contact_relation_id = 0,
  email1 = undefined,
  relation = '',
  is_company = 0,
  birthdate = undefined,
  main_contact_for_artist_flag = undefined,
  contract_flag = undefined,
  phone1 = undefined,
  passport_no = undefined,
  contact_id = 0
} = {}) => {
  return {
    contact_name,
    last_modified,
    travel_flag,
    request_flag,
    phone2,
    main_company_flag,
    contact_relation_id,
    email1,
    relation,
    is_company,
    birthdate,
    main_contact_for_artist_flag,
    contract_flag,
    phone1,
    passport_no,
    contact_id
  }
};


const createLocations = ({
  booking_status_colour = undefined,
  artist_name = '',
  start_date = '',
  calendar_date_id = 0,
  performance_type = '',
  promoter_name = '',
  artist_id = 0
}) => {
  return {
    booking_status_colour,
    artist_name,
    start_date,
    calendar_date_id,
    performance_type,
    promoter_name,
    artist_id
  }
};

const createRelatedGenre = ({
  genre_relation_id = 0,
  rank = undefined,
  genre_id = 0,
  last_modified = '',
  genre_name = ''
} = {}) => {
  return {
    genre_relation_id,
    rank,
    genre_id,
    last_modified,
    genre_name
  }
};


const createUser = ({
  booking_report_flag = 0,
  contact_id = undefined,
  publishing_more_flag = 0,
  user_id = 0,
  smtp_username = undefined,
  created = '',
  general_flag = 0,
  dashboard_settings = createDashboard_settings({}),
  contacts_flag = 0,
  accounting_more_flag = 0,
  staff_email = '',
  staff_fullname = undefined,
  smtp_password = undefined,
  permissions = createPermissions({}),
  publishing_flag = 0,
  last_modified = '',
  general_settings_flag = 0,
  job_title = undefined,
  smtp_server = undefined,
  management_flag = 0,
  user_name = '',
  booking_flag = 0,
  promotion_flag = 0,
  signature_link = undefined,
  booking_more_flag = 0,
  client_code = undefined,
  label_flag = 0,
  accounting_flag = 0,
  language = '',
  password = '',
  distribution_flag = 0,
  staff_phone2 = undefined,
  staff_phone1 = undefined,
  contact_export_import_flag = 0,
  module_settings_flag = 0,
  user_settings_flag = 0,
  general_more_flag = 0,
  label_more_flag = 0
}) => {
  return {
    booking_report_flag,
    contact_id,
    publishing_more_flag,
    user_id,
    smtp_username,
    created,
    general_flag,
    dashboard_settings,
    contacts_flag,
    accounting_more_flag,
    staff_email,
    staff_fullname,
    smtp_password,
    permissions,
    publishing_flag,
    last_modified,
    general_settings_flag,
    job_title,
    smtp_server,
    management_flag,
    user_name,
    booking_flag,
    promotion_flag,
    signature_link,
    booking_more_flag,
    client_code,
    label_flag,
    accounting_flag,
    language,
    password,
    distribution_flag,
    staff_phone2,
    staff_phone1,
    contact_export_import_flag,
    module_settings_flag,
    user_settings_flag,
    general_more_flag,
    label_more_flag
  }
};


const createDashboard_settings = ({

}) => {
  return {

  }
};



const createPermissions = ({
  allowed = createAllowed({}),
  blocked = createBlocked({})
}) => {
  return {
    allowed,
    blocked
  }
};


const createAllowed = ({
  roles = ['']
}) => {
  return {
    roles
  }
};



const createBlocked = ({
  tabs = [''],
  sub_menu = ['']
}) => {
  return {
    tabs,
    sub_menu
  }
};





const createLocation = ({
  address1 = '',
  keywords = undefined,
  last_modified = '',
  age_limit = undefined,
  curfew = undefined,
  merchandise_info = '',
  sponsoring_info = undefined,
  booking_location_name = '',
  clientID = undefined,
  created = '',
  country = '',
  city = '',
  address2 = '',
  phone1 = '',
  email = '',
  mechanical_info = undefined,
  url2 = undefined,
  google_place_id = '',
  longitude = undefined,
  url1 = '',
  fax = '',
  booking_location_id = 0,
  type = '',
  feature = '',
  original_id = undefined,
  market_area = '',
  phone2 = undefined,
  dist_to_airport = undefined,
  opening_time = undefined,
  ksk_info = undefined,
  venue_capacity = 0,
  postalcode = 0,
  latitude = 0
}) => {
  return {
    address1,
    keywords,
    last_modified,
    age_limit,
    curfew,
    merchandise_info,
    sponsoring_info,
    booking_location_name,
    clientID,
    created,
    country,
    city,
    address2,
    phone1,
    email,
    mechanical_info,
    url2,
    google_place_id,
    longitude,
    url1,
    fax,
    booking_location_id,
    type,
    feature,
    original_id,
    market_area,
    phone2,
    dist_to_airport,
    opening_time,
    ksk_info,
    venue_capacity,
    postalcode,
    latitude
  }
};



const createStatus = ({
  default_status_booking_flag = 0,
  publish_to_website_flag = 0,
  last_modified = '',
  booking_status_colour = '',
  publish_to_artist_flag = 0,
  created = '',
  booking_status_id = 0,
  booking_status_name = '',
  hide_free_on_date_flag = undefined
}) => {
  return {
    default_status_booking_flag,
    publish_to_website_flag,
    last_modified,
    booking_status_colour,
    publish_to_artist_flag,
    created,
    booking_status_id,
    booking_status_name,
    hide_free_on_date_flag
  }
};



const createArtists = ({
  default_techrider_eng = '',
  techrider_url = '',
  default_travel_eng = undefined,
  last_modified = '',
  default_setup_time = undefined,
  default_travel_own = undefined,
  artist_type = '',
  default_travel_option2 = undefined,
  default_agent_commission = undefined,
  default_performance_time_contract = undefined,
  signature_url = '',
  created = '',
  default_guestlist_tickets = 0,
  vat_type_id = undefined,
  default_hotel_eng = undefined,
  url2 = '',
  default_single_rooms = 0,
  default_techrider_own = undefined,
  default_hotel_stars = 0,
  performance_type = '',
  main_contact_id = 0,
  cost_center = undefined,
  url3 = '',
  artist_id = 0,
  url1 = undefined,
  artist_announcement = '',
  artist_name = '',
  default_suites = undefined,
  default_catering_own = '',
  default_travel_qty = 0,
  password = '',
  language = '',
  short_name = undefined,
  default_catering_eng = undefined,
  free_on_date_flag = undefined,
  notes = undefined,
  travel_options = '',
  default_hotel_own = undefined,
  default_feedback = undefined,
  default_double_rooms = undefined,
  user_name = '',
  tripit_ical = undefined
}) => {
  return {
    default_techrider_eng,
    techrider_url,
    default_travel_eng,
    last_modified,
    default_setup_time,
    default_travel_own,
    artist_type,
    default_travel_option2,
    default_agent_commission,
    default_performance_time_contract,
    signature_url,
    created,
    default_guestlist_tickets,
    vat_type_id,
    default_hotel_eng,
    url2,
    default_single_rooms,
    default_techrider_own,
    default_hotel_stars,
    performance_type,
    main_contact_id,
    cost_center,
    url3,
    artist_id,
    url1,
    artist_announcement,
    artist_name,
    default_suites,
    default_catering_own,
    default_travel_qty,
    password,
    language,
    short_name,
    default_catering_eng,
    free_on_date_flag,
    notes,
    travel_options,
    default_hotel_own,
    default_feedback,
    default_double_rooms,
    user_name,
    tripit_ical
  }
};



const createClient = ({
  display_name = ''
}) => {
  return {
    display_name
  }
};


const createComment = ({
  table_id = 0,
  table_name = '',
  comment = '',
  score = undefined,
  subject = undefined,
  clientID = '',
  status = '',
  comment_id = 0,
  user_name = '',
  created = ''
} = {}) => {
  return {
    table_id,
    table_name,
    comment,
    score,
    subject,
    clientID,
    status,
    comment_id,
    user_name,
    created
  }
};



const createPromoters = ({
  last_name = undefined,
  mobile2 = undefined,
  account_holder = undefined,
  date_start = undefined,
  cost_center = undefined,
  swift = undefined,
  ID_on_client = 0,
  aim = undefined,
  currency_id = undefined,
  default_declaration_text1 = undefined,
  skype = undefined,
  vat_no_confirmed = undefined,
  tablename = '',
  main_promoter = undefined,
  url4 = undefined,
  iban = undefined,
  email1 = '',
  sortcode = undefined,
  chat3 = undefined,
  nick_name = undefined,
  c_email = '',
  last_modified = undefined,
  postbox = undefined,
  invoice_discount_days = undefined,
  birthdate = undefined,
  tax_no = '',
  default_declaration_text2 = undefined,
  cost_discount_days = undefined,
  promoter_id = 0,
  vat_type_id = undefined,
  contact_id = 0,
  debitor_no = undefined,
  account_no = undefined,
  identifier = 0,
  clientID = '',
  invoice_discount_percent = undefined,
  gender = undefined,
  cost_end_of_month_flag = undefined,
  phone1 = '',
  passport_no = undefined,
  country = '',
  fax1 = undefined,
  invoice_end_of_month_flag = undefined,
  cost_payment_method_id = undefined,
  email2 = undefined,
  title = undefined,
  phone2 = undefined,
  invoice_payment_method_id = undefined,
  promoter_interface = undefined,
  company_name = '',
  url1 = '',
  url3 = undefined,
  bank_name = undefined,
  postalcode = '',
  formality = undefined,
  p_email = '',
  mobile1 = undefined,
  language = undefined,
  notes = undefined,
  cost_due_days = undefined,
  iCal_password = undefined,
  fax2 = undefined,
  creditor_no = undefined,
  invoice_due_days = undefined,
  request = undefined,
  vat_no = '',
  address1 = '',
  url2 = undefined,
  valid_vat_no_flag = 0,
  bank_address = undefined,
  first_name = undefined,
  region = undefined,
  customer_no = undefined,
  address2 = '',
  date_end = undefined,
  city = '',
  created = '',
  company_legalname = undefined,
  cost_discount_percent = undefined
}) => {
  return {
    last_name,
    mobile2,
    account_holder,
    date_start,
    cost_center,
    swift,
    ID_on_client,
    aim,
    currency_id,
    default_declaration_text1,
    skype,
    vat_no_confirmed,
    tablename,
    main_promoter,
    url4,
    iban,
    email1,
    sortcode,
    chat3,
    nick_name,
    c_email,
    last_modified,
    postbox,
    invoice_discount_days,
    birthdate,
    tax_no,
    default_declaration_text2,
    cost_discount_days,
    promoter_id,
    vat_type_id,
    contact_id,
    debitor_no,
    account_no,
    identifier,
    clientID,
    invoice_discount_percent,
    gender,
    cost_end_of_month_flag,
    phone1,
    passport_no,
    country,
    fax1,
    invoice_end_of_month_flag,
    cost_payment_method_id,
    email2,
    title,
    phone2,
    invoice_payment_method_id,
    promoter_interface,
    company_name,
    url1,
    url3,
    bank_name,
    postalcode,
    formality,
    p_email,
    mobile1,
    language,
    notes,
    cost_due_days,
    iCal_password,
    fax2,
    creditor_no,
    invoice_due_days,
    request,
    vat_no,
    address1,
    url2,
    valid_vat_no_flag,
    bank_address,
    first_name,
    region,
    customer_no,
    address2,
    date_end,
    city,
    created,
    company_legalname,
    cost_discount_percent
  }
};



